import { Box, CircularProgress, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';

interface LoadingSpinnerProps {
  size?: number;
  fullscreen?: boolean;
  message?: string;
}

const breatheAnimation = keyframes`
  0% { opacity: 0.7; transform: scale(0.95); }
  50% { opacity: 1; transform: scale(1); }
  100% { opacity: 0.7; transform: scale(0.95); }
`;

export function LoadingSpinner({ 
  size = 40, 
  fullscreen = false,
  message = "Loading..." 
}: LoadingSpinnerProps) {
  const content = (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center',
      animation: `${breatheAnimation} 2s infinite ease-in-out`
    }}>
      <CircularProgress 
        size={size} 
        thickness={4}
        sx={{ 
          color: (theme) => theme.palette.primary.main,
          mb: message ? 2 : 0
        }} 
      />
      {message && (
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            fontWeight: 500,
            opacity: 0.8 
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );

  if (fullscreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (theme) => theme.palette.mode === 'light' 
            ? 'rgba(255, 255, 255, 0.85)' 
            : 'rgba(17, 24, 39, 0.85)',
          backdropFilter: 'blur(4px)',
          zIndex: 9999,
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        minHeight: '200px',
      }}
    >
      {content}
    </Box>
  );
}